import { Title, Avatar, Grid, ThemeIcon } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import ProfilePicture from "../images/profile-pic-2.jpg";
import { motion } from "framer-motion";
import { IconArrowDown } from "@tabler/icons";

function Home() {
  const { height, width } = useViewportSize();
  // let picSize: number = height / 3;
  let picRadius: number = width;

  return (
    <Grid justify="space-around" align="center" style={{ minHeight: height }}>
      <Grid.Col span="content" md={4} >
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ ease: [0, 0.71, 0.2, 1.01], delay: 0.5, duration: 0.8 }}
        >
          <Avatar src={ProfilePicture} radius={picRadius} size={375}/>
        </motion.div>
      </Grid.Col>
      <Grid.Col sm={12} md="content" ml={{ md: 75}}>
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ ease: "anticipate", delay: 1.5, duration: 0.8 }}
        >
          <Title
            order={1}
            variant="gradient"
            gradient={{ from: "blue", to: "blue.4" }}
            fz={{ base: 65, xs: 65, sm: 65 }}
            ta={{ base: "center", md: "left" }}
          >
            Hi! I'm Raphael!
          </Title>
          <Title
            color="dimmed"
            order={1}
            size="h3"
            fw={400}
            ta={{ base: "center", md: "left" }}
            
          >
            Welcome To My Website
          </Title>
        </motion.div>
      </Grid.Col>

      <Grid.Col>
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          // animate={{ scale: 1, opacity: 1 }}
          transition={{ ease: [0, 0.71, 0.2, 1.01], delay: 2.5, duration: 0.8 }}
          whileInView={{ scale: 1, opacity: 1 }}
        >
          <ThemeIcon
            size={80}
            variant="gradient"
            gradient={{ from: "blue", to: "blue.4" }}
            radius={50}
          >
            <IconArrowDown size={65} />
          </ThemeIcon>
        </motion.div>
      </Grid.Col>
    </Grid>
  );
}

export default Home;
